var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVietnamFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1987_51931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000488281H27V19.9995H0V-0.000488281Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4984 3.99951L10.3214 14.8495L18.6374 8.14951H8.35938L16.6754 14.8495L13.4984 3.99951Z",
    fill: "#FFEB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1987_51931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnamFlag);
export default __webpack_public_path__ + "static/media/vietnam-flag.2f74b22e8bb85ec89819c31e1df4690d.svg";
export { ForwardRef as ReactComponent };